<template>
    <Modal v-model="currValue" :title="title" :scrollable="true" :footer-hide="detail" width="600">
        <Spin size="large" fix v-if="loading"></Spin>
        <Form ref="form" :model="formData" :label-width="120">
            <FormItem label="批准签名" prop="approveSignPic" :rules="[rules.required]">
                <draw-canvas :reset="drawReset" @on-change="signChange"></draw-canvas>
            </FormItem>
        </Form>

        <div slot="footer">
            <Button @click="currValue=false">取消</Button>
            <Button type="primary" @click="handleSubmit">批准</Button>
        </div>
    </Modal>
</template>

<script>
    import iEquip from "@/module/main/api/iEquip";
    import modalHelper from "@/mixins/modalHelper";
    import rules from '@/libs/rules';
    import _don from "@/libs/doson";
    import DrawCanvas from '@/components/DrawCanvas.vue';

    const formModal = {
        id:null,
        checkStatus:2,
        approveSignPic:null
    };

    export default {
        name: "report-approve",
        mixins: [modalHelper],
        components: {
            DrawCanvas
        },
        props:{
            equipId:{
                type:Number,
                default:0
            },
            detail:{
                type:Boolean,
                default:false
            }
        },
        data() {
            return {
                rules,
                formData: _don.cloneWithModal(formModal),
                title:'检测报告批准',
                drawReset:0
            }
        },
        activated() {
            this.init();
        },
        methods: {
            init() {

            },
            setFormData() {
                _don.cloneWithModal(formModal, this.formData, this.dataSource);
            },
            async handleSubmit() {
                if (!await this.$refs.form.validate()) return;
                if (!this.formData.approveSignPic || !this.formData.approveSignPic.startsWith('data:image')) {
                    this.$Message.error('您还未签名，签名完成请点确定后再提交！');
                }
                // 提交
                iEquip.reportUpdateCheck(this.formData.id, 2, null, null, this.formData.approveSignPic).then(() => {
                    this.$Message.success('操作成功');
                    this.$emit('on-success', this.formData);
                    this.currValue = false;
                }).loadingSwitch(this, 'loading');
            },
            signChange(v){
                if (!v) {
                    this.formData.approveSignPic = null
                    return
                }
                this.formData.approveSignPic = v;
            }
        },
        computed: {

        },
        watch:{
            /*value(val) {
                // 加载窗口
                if (this.currValue !== val) {
                    this.currValue = val;
                }
                if (val) {// 加载表单数据
                    this.setFormData()
                    this.drawRest = 1
                } else {
                    this.drawRest = 0
                }

            },*/
            currValue(val) {
                // 关闭窗口
                if (!val && this.value !== val) {
                    this.$refs.form && this.$refs.form.resetFields()
                    this.drawReset = 0
                    this.$nextTick(()=> {
                        this.$emit('input', false);
                    })
                } else {
                    this.drawReset = 1
                }
            },
        }
    }
</script>

<style scoped>
    .form-tip {
        color:#ff0000;
        font-size:14px;
        line-height:28px;
    }
</style>
